import React from 'react'
import FormSousCatégorie from '../../Components/FormSousCatégorie'

const AjouterSousCatégorie = () => {
  return <FormSousCatégorie />
}

export default AjouterSousCatégorie
